import {SvgSexTwoLearnMore, SvgSexCondom,SvgSexOneLearnMore, SvgSexTwoAEnd } from "components/Images/sex";

const sexTwo = [
      {
        id: 'sex-2-learnmore',
        type: 'learnmore',
        text: '<p>Amari and Jamie appear to be enjoying themselves. Amari is keen to take their relationship to the next level, but Jaime isn’t sure and wants to talk about it.</p><p>Having sex for the first time (or with a new partner) is a big decision and may make you feel nervous, anxious, excited or confused.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexTwoLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>Some things to consider when thinking about having sex for the first time:</p><p>Is this something YOU want to do? Are you emotionally ready? Do you feel safe with the person you&rsquo;re with? Are you BOTH comfortable and ready for it?</p><p>Once you both feel ready other things you should consider are:<br />- Have you and your partner had a sexual health check recently?<br />- Have you talked about using condoms to protect you and your partner from sexually transmissible infections (STIs)?<br />- If you or are your partner are at risk for unintended pregnancy, have you talked about contraception?</p><p>Click <a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships/" target="_blank">here</a> for more information.</p>'
        },
        nextStepId: 'sex-2a',
      },
      {
        id: 'sex-2a',
        type: 'question',
        text: "<p>Amari says: I just want you to know that I really like you. What we’ve been doing so far has really worked for me and I’m so ready.</p><p>How does the night proceed?</p>",
        backgroundImage: SvgSexTwoLearnMore,
        options: [
          {
            id: 'sex-2a-option-1',
            text: 'Jamie says: “I’m just not sure and it’s important to me that I’m ready before having sex. I love being with you, I just don’t want to regret anything.”',
            icon: '😯',
            iconBackground: '#fbe9b6',
            nextStepId: 'sex-2a-learnmore'
          },
          {
            id: 'sex-2a-option-2',
            text: 'Jamie says: “I’ve been thinking about this a lot.  If we are going to have sex tonight, let’s talk about how we do it safely. Did you bring condoms?”',
            icon: SvgSexCondom,
            iconType: 'svg',
            iconBackground:'#c9e9ff',
            nextStepId: 'sex-2b-learnmore',
  
          }
        ]
      },
   
      {
        id: 'sex-2a-learnmore',
        type: 'learnmore',
        text: '<p>Jamie appears to be unsure about whether they are ready to have sex. Both Amari and Jamie need to feel emotionally and physically ready to have sex. They should be confident that they’ve made the right decision for themselves.</p><p>No one should feel pressured by their partner to do something they’re not ready for.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage:SvgSexTwoLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>It is OK for you to take your time when deciding whether you&rsquo;re ready to have sex. You should make sure you are comfortable and can communicate what you are and are not willing to do.</p><p>Open communication, trust and respect will make the time you spend with your partners a lot more satisfying and enjoyable.</p><p>Visit <a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships/" target="_blank">Body Talk</a> for more information</p>'
        },
        nextStepId: 'sex-2a-end',
      },
      {
        id: 'sex-2a-end',
        type: 'learnmore',
        text: "<p>Amari says, &ldquo;Of course, I don&rsquo;t want you to feel pressure if you're not ready. I&rsquo;m happy to keep doing what we&rsquo;ve been doing. I&rsquo;m having a lot of fun.</p><p><p>Jamie smiles at Amari and says: &ldquo;I&rsquo;m glad we&rsquo;ve started the conversation. Let&rsquo;s keep talking about it. But it doesn&rsquo;t have to be now. I&rsquo;m starving! Let&rsquo;s go get something to eat back at the festival.&rdquo;</p></p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage:SvgSexTwoAEnd,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Communication is a key part of building and maintaining a respectful, healthy relationship. Communication helps you to make sure you both want and expect the same things, and involves talking and listening to one another.</p>"
        },
        nextStepId: null,
      },
      {
        id: 'sex-2b-learnmore',
        type: 'learnmore',
        text: '<p>Jamie appears to be to ready but wants to make sure that they are both on the same page when it comes to safe sex.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage:SvgSexTwoLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>Talking with partners about preventing STIs and unintended pregnancy is one of the most important things people can do to protect each other and improve their sexual health. Condoms give the best protection against STIs. People should use a condom every single time they have sex, including vaginal, anal or oral sex.</p><p>Visit <a href="https://bodytalk.org.au/keeping-an-eye-on-stis/your-best-defence/" target="_blank">Body Talk</a> for more information</p>'
        },
        nextStepId: 'sex-2b-1-2',
      },

      {
        id: 'sex-2b-1-2',
        type: 'question',
        text: "<p>Amari realises they don&rsquo;t have condoms and says: &ldquo;I wasn&rsquo;t thinking this was going to happen tonight.&rdquo;</p>",
        backgroundImage:  SvgSexTwoLearnMore,
        options: [
          {
            id: 'sex-2a-option-1',
            text: 'Jamie and Amari walk down to a servo to pick some up. Once they have them, Amari checks in with Jamie to make sure they are still up for sex. Jamie smiles, and says “are you?” They both nod and snuggle up.',
            icon: SvgSexCondom,
            iconType: 'svg',
            iconBackground: '#c5d2ff',
            nextStepId: 'sex-2b-1-2-end'
          },
          {
            id: 'sex-2a-option-2',
            text: 'Jamie and Amari decide to pause on sex but are happy to continue kissing and cuddling. Later they discuss where they might be able to get free condoms for next time.',
            icon: '🥰',
            iconBackground:'#fbe9b6',
            nextStepId: 'sex-2b-1-2-end',
  
          }
        ]
      },
      {
        id: 'sex-2b-1-2-end',
        type: 'learnmore',
        text: "<p>Jamie and Amari agree that they need condoms for taking it the next level. Condoms give the best protection against STIs. People should use a condom every single time they have sex, including vaginal, anal or oral sex.</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>Condoms are available in supermarkets, servos, pharmacies/chemists and online stores. But the cost can add up. Did you know that you can get condoms for free at sexual health clinics, youth services and Family Planning NSW?&nbsp;</p><p><br />Family Planning NSW&rsquo;s Freedom Condom project is a friendly, confidential way for young people to access free condoms, lube and sexual health information. Visit <a href="https://www.freedomcondom.org.au/" target="_blank">https://www.freedomcondom.org.au</a> for more information.</p>'
        },
        nextStepId: null,
      },

]


export default sexTwo